import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { UploadImageResultType } from '../../../../../../types/common.type'

@Component({
  selector: 'bmcore-upload-progr-bar',
  templateUrl: './bmcore-upload-progr-bar.component.html',
  styleUrls: ['./bmcore-upload-progr-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreUploadProgrBarComponent implements OnInit {
  @Input() file: File
  @Input() uploadImageResult: UploadImageResultType

  constructor() {}

  ngOnInit(): void {}

  convertSize(sizeInBytes: number) {
    return (sizeInBytes / (1024 * 1024)).toFixed(2)
  }
}
